import { IUploadCenterFileResult } from "./upload-center-file-result";

export interface IUploadCenterFilesResponse {
    data: {
        success: boolean;
        message: "";
        results: IUploadCenterFileResult[];
    }
}